import React, { Component } from "react";
import { deleteTokens, deleteLogin } from "../../auth";

export default function (ComposedComponent) {
  class NetworkDetector extends Component {
    componentDidMount() {
      this.handleConnectionChange();
      window.addEventListener("online", this.handleConnectionChange);
      window.addEventListener("offline", this.handleConnectionChange);
    }

    componentWillUnmount() {
      window.removeEventListener("online", this.handleConnectionChange);
      window.removeEventListener("offline", this.handleConnectionChange);
    }

    handleConnectionChange = () => {
      const condition = navigator.onLine ? "online" : "offline";
      if (condition === "online") {
        const webPing = setInterval(() => {
          fetch("https://google.com", {
            mode: "no-cors",
          })
            .then(() => {
              return clearInterval(webPing);
            })
            .catch(() => {
              const pathName = window.location.pathname.split("/")[1];
              if (pathName !== "login") {
                window.location.href = "/login";
              }
              deleteTokens();
              deleteLogin("login");
            });
        }, 2000);
        return;
      }

      const pathName = window.location.pathname.split("/")[1];
      if (pathName !== "login") {
        window.location.href = "/login";
      }
      deleteTokens();
      deleteLogin("login");
      return;
    };

    render() {
      return <ComposedComponent {...this.props} />;
    }
  }

  return NetworkDetector;
}
